import networkService from '../../../Network/NetworkManager';
import APPURL from '../../../Constants/URLConstants';
import {AxiosCall} from '../../../Network/AxiosCall';
import {getCartList} from '../../../Actions/getCartList';
import ToastPopup from '../../../HelperClasses/AppLoaderClasses/ToastPopup';
import {onFetchCart} from './OnFetchCart';

export const fetchShippingMethods = async ({
  setShippingMethods,
  setSelectedShippingMethod,
  setIsLoading,
  selectedUser,
  pk_key,
}) => {
  try {
    setIsLoading(true);

    const responseJson = await AxiosCall({
      method: 'GET',
      path: APPURL.URLPaths.tenantShippingMethod,
      pk_key,
      auth_key: selectedUser?.key.auth_key,
    });
    setShippingMethods(responseJson?.data?.data?.shipping_methods);
    setSelectedShippingMethod(responseJson?.data?.data?.shipping_methods[0]);
    setIsLoading(false);
  } catch (error) {
    setIsLoading(false);
    ToastPopup({
      message:
        error?.response?.data?.error?.message ||
        'Failed to fetch shipping methods',
      type: 'error',
    });
  }
};
